package app.bloomey.web.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.button
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.focusOutline

@InitSilk
fun initTheme(context: InitSilkContext) {
    context.theme.palettes.light.apply {
        val palette = SitePalettes.light
        background = palette.background
        color = palette.onBackground
        focusOutline = palette.brand.primary
        button.apply {
            default = Color.argb(0xff1E1E1E)
            pressed = palette.brand.primary
            hover = palette.brand.primary
        }
    }

    context.theme.palettes.dark.apply {
        val palette = SitePalettes.dark
        background = palette.background
        color = palette.onBackground
        focusOutline = palette.brand.primary
        button.apply {
            default = Color.argb(0xff1E1E1E)
            pressed = palette.brand.primary
            hover = palette.brand.primary
        }
    }
}
